import type { FC } from "react";
import { Card, CardRowSimple, type GridCard, LoadingSpinner } from "widgets";

import { FormWarning } from "@/ui-modules/core/form/layout/FormWarning.tsx";
import { useGetPlaybookEventErrorsCardQuery } from "@/ui-modules/playbooks/events/graphql/event-queries.gql.ts";

export interface IPlaybookEventErrorsCardProps extends GridCard {
  eventId: number;
}

export const PlaybookEventErrorsCard: FC<IPlaybookEventErrorsCardProps> = ({ eventId }) => {
  const { data, loading } = useGetPlaybookEventErrorsCardQuery({
    variables: { eventId: eventId },
  });

  const errorNumber: number | undefined = data?.playbook?.event?.getErrors?.length;

  return (
    errorNumber &&
    errorNumber > 0 && (
      <Card key="event-error-card" title={"Errors"} shrinkable={errorNumber > 7} tag={{ label: String(errorNumber) }}>
        {loading ? (
          <LoadingSpinner />
        ) : (
          <>
            {data?.playbook?.event?.getErrors?.map((error, idx) => (
              <CardRowSimple key={`event-error-${idx}`} value={<FormWarning>{error}</FormWarning>} />
            ))}
          </>
        )}
      </Card>
    )
  );
};
